import { DiffType } from '@ardoq/data-model';
import { BULK_POPOVER_ATTR } from '@ardoq/popovers';
import { MODEL_ID_ATTRIBUTE } from 'consts';

export const getChangedPopover = (
  id: string | undefined,
  diffType: DiffType
): Record<string, string> =>
  id && diffType === DiffType.CHANGED
    ? {
        [BULK_POPOVER_ATTR]: 'true',
        [MODEL_ID_ATTRIBUTE]: id,
      }
    : {};
